/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-08-09 15:32:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-23 15:18:10
 * @FilePath: /mall-fe/src/views/web/home/NewIndex/index.tsx
 * @Description: 商城对外首页入口文件
 *
 */
// import Header from './components/Header';
import HomeBannerNew from './components/HomeBannerNew';
// import CategoryGoodsList from './components/CategoryGoodsList';
// import SmartRecommend from './components/SmartRecommend';
import Footer from './components/Footer';
import BrandPics from 'comps/BrandPics';
// import HomeInnovative from 'comps/HomeInnovative';
import HomeHireBanner from 'comps/HomeHireBanner';
import ProjectNewAddCard from '@/biz-components/web/ProjectNewAddCard';
import FactoryDirect from './components/FactoryDirect';
import HomeFloor from './components/HomeFloor';
import MallServiceAdvantage from './components/MallServiceAdvantage';
interface CategoryItem {
  title: string;
  iconUrl: string;
  id: string;
  link: string;
  children: CategoryItem[];
}
interface NewIndexProps {
  floorsData: Array<FloorsProps>;
  bannersData: BannerInfo[];
  bulletinData: BulletinDataInfo[];
  categorys: CategoryItem[];
  newIndexRecommendData: any;
  newIndexHotData: Array<FloorsProps>;
  // skuStatisticsData: any;
  brands: Array<{
    image: string;
    link: string;
    title: string;
  }>;
  outwardHireBannerData: BannerInfo[];
  projectNewAddListData: any;
  factoryDirectListData: any;
}

const NewIndex = (props: NewIndexProps) => {
  const {
    bannersData,
    bulletinData,
    categorys,
    // skuStatisticsData,
    floorsData,
    brands,
    // newIndexRecommendData,
    newIndexHotData,
    outwardHireBannerData,
    projectNewAddListData,
    factoryDirectListData,
  } = props;
  return (
    <div className="index">
      {/* <Header /> */}
      <HomeBannerNew banners={bannersData} bulletinData={bulletinData} categorys={categorys} />
      {/* 对外商城首页招租广告位 */}
      {outwardHireBannerData?.length > 0 && <HomeHireBanner banners={outwardHireBannerData} />}
      {/* <HomeMaterialPrice skuStatisticsData={skuStatisticsData} /> */}
      {/* <HomeInnovative /> */}
      {!!factoryDirectListData?.length && (
        <FactoryDirect
          floorData={{
            title: '厂家直采',
            children: factoryDirectListData,
          }}
        />
      )}
      {!!projectNewAddListData?.datas?.length && (
        <ProjectNewAddCard projectList={projectNewAddListData.datas} />
      )}
      {/* {newIndexRecommendData?.length ? (
        <SmartRecommend
          showMoreBtn={false}
          maxShowNum={4}
          projectNewAddListData={projectNewAddListData}
          floorData={{
            title: '智能推荐',
            children: newIndexRecommendData,
          }}
        />
      ) : (
        ''
      )} */}
      <HomeFloor hotData={newIndexHotData} floorsData={floorsData} />
      <MallServiceAdvantage />
      {/* {[...newIndexHotData, ...floorsData].map((floor) => (
        <CategoryGoodsList key={floor.id} floorData={floor} />
      ))} */}
      <BrandPics brands={brands} title="第三方电商平台" />
      <Footer />
      <style jsx>{`
                .index {
                    background-color: #f1f3f5;
                }
                // .index :global(.ant-tabs-nav-wrap) {
                //     justify-content: flex-end;
                // }
                // .index :global(.ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right) {
                //     justify-content: flex-start;
                // }
                // .index :global(.ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left) {
                //     justify-content: flex-start;
                // }
            `}</style>
    </div>
  );
};

export default NewIndex;
